import Instance from "../../../../Axios";

// New Actions for the app

const GetCredInqueritoPessoal = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/inqueritoPessoal`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_INQUERITO_PESSOAL",
        payload: data.yData[0],
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredInqueritoPessoal;
